<template>
  <div class="bg" v-if="show">
    <div @click="bgClose" class="greyBg"></div>
    <div v-if="showPhone && c.platformType != 'b_plus' && c.platformType != 'dy'" :style="'font-size:'+fontSize+'px'" class="phone-container">
      <img v-show="!c.noClose" @click="close" class="close" src="./assets/close.png" alt="">
      <div class="phone">
        <img class="topLine" src="./assets/phoneTop.png" alt="">
        <div class="phoneScroll">
          <video ref="fVideo" :src="info.url" :poster="info.cover" controls controlslist="nodownload"></video>
          <img src="./assets/tab.png" alt="">
          <div class="title">
            <div class="l">{{info.title}}</div>
            <div class="r"></div>
          </div>
          <img src="./assets/num.png" alt="">
          <div class="content">{{info.info}}</div>
        </div>
        <div class="tags">
          <p v-for="(item,index) in info.tags" :key="index">{{item}}</p>
        </div>
        <img class="bottomBtn" src="./assets/bottom.png" alt="">
      </div>
    </div>
    <div v-if="!showPhone && c.platformType != 'b_plus' && c.platformType != 'dy'" class="pc-container">
      <!-- <iframe style="width: 100%;height: 100%" :src="info.preview_pc_url" frameborder="0" allowfullscreen></iframe> -->
      <div class="title">{{info.title}}</div>
      <img class="pcNumber" src="./assets/pcNum.png" alt="">
      <video ref="fVideo" :src="info.url" :poster="info.cover" controls controlslist="nodownload"></video>
      <img class="pcWatch" src="./assets/pcWatch.png" alt="">
      <div class="content">{{info.info}}</div>
      <div class="tags">
        <p v-for="(item,index) in info.tags" :key="index">{{item}}</p>
      </div>
      <!-- <img class="pcTag" src="./assets/pcTag.png" alt=""> -->
      <img @click="close" class="close" src="./assets/close.png" alt="">
    </div>

    <div class="switch-container">
      <div @click="showPhone = true" :class="{btn: true, un: !showPhone, bili: true}">
        <img src="./assets/biliIcon.png" alt="">
        <p>移动端</p>
      </div>
      <div @click="showPhone = false" :class="{btn: true, un: showPhone, bili: true}">
        <img src="./assets/biliIcon.png" alt="">
        <p>PC端</p>
      </div>
    </div>
  </div>
</template>

<script>
import common from "@common/common";
import { apis } from "@common/config";
import vClickOutside from "v-click-outside";

export default {
  name: 'shareCode',
  directives: {
    clickOutside: vClickOutside.directive
  },
  data() {
    return {
      toggleShow: true,
      show: true,
      fontSize: 100,
      showPhone: true,
      c: {},
      isPlay: false,
      num: 0,
      info: {
        preview_mobile_url: '',
        preview_pc_url: ''
      },
      platformType: '',
      isInit: false,
    }
  },
  methods: {
    getPreview(id) {
      let info = {
        id: id
      }

      common.myFetch(apis.getCommonPreview, info).then(r => {
        if (r) {
          console.log(r)
          this.isInit = true;
          if(r.tags){
            r.tags = r.tags.split(',')
          }else{
            r.tags = []
          }
          this.info = r
        }
      });
    },
    playVideo() {
      // console.log(123,this.c,this.isPlay)
      if(!this.isPlay){
        if(this.c.platformType == "b_plus"){
          this.$refs.bVideo.play()
        }else if(this.c.platformType == "dy"){
          this.$refs.cVideo.play()
        }
      }else{
        if(this.c.platformType == "b_plus"){
          this.$refs.bVideo.pause()
        }else if(this.c.platformType == "dy"){
          this.$refs.cVideo.pause()
        }
      }
      this.isPlay = !this.isPlay
    },
    open(c, r) {
      this.isInit = false;
      this.getPreview(c)
    },
    bgClose() {
      if(this.c.newPreview) return
      if(this.$refs.aVideo){
        this.$refs.aVideo.pause()
      }
      if(this.$refs.bVideo){
        this.$refs.bVideo.pause()
      }
      if(this.$refs.cVideo){
        this.$refs.cVideo.pause()
      }
      if(this.$refs.fVideo){
        this.$refs.fVideo.pause()
      }
      this.show = false
      this.isInit = false;
    },
    close() {
      if(this.$refs.aVideo){
        this.$refs.aVideo.pause()
      }
      if(this.$refs.bVideo){
        this.$refs.bVideo.pause()
      }
      if(this.$refs.cVideo){
        this.$refs.cVideo.pause()
      }
      if(this.$refs.fVideo){
        this.$refs.fVideo.pause()
      }
      this.show = false
      this.isInit = false;
    },
    recalc() {
        var clientWidth = document.documentElement.clientWidth;

        if (!clientWidth) {

            return;
        }

        var p = 100 * (clientWidth / 1920);

        this.fontSize = p

        // console.log(this.$refs.bg.getBoundingClientRect().width)

        // if(this.$refs.bg.getBoundingClientRect()){
        //     this.bgHeight = this.$refs.bg.getBoundingClientRect().width * 314 / 1262
        // }
    },
    js_getDPI() {
      var arrDPI = new Array();
      if ( window.screen.deviceXDPI != undefined ) {
          arrDPI[0] = window.screen.deviceXDPI;
          arrDPI[1] = window.screen.deviceYDPI;
      }
      else {
          var tmpNode = document.createElement( "DIV" );
          tmpNode.style.cssText = "width:1in;height:1in;position:absolute;left:0px;top:0px;z-index:99;visibility:hidden";
          document.body.appendChild( tmpNode );
          arrDPI[0] = parseInt( tmpNode.offsetWidth );
          arrDPI[1] = parseInt( tmpNode.offsetHeight );
          tmpNode.parentNode.removeChild( tmpNode );
      }
      return arrDPI;
    }
  },
  mounted() {
    let resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize';
    window.addEventListener(resizeEvt, this.recalc, false);

        this.recalc()
  }
}
</script>

<style>
.phone-container .imgBtnsEdit {
  display: none;
}

.phone-container .imgBtnsAdd {
  display: none;
}

.pc-container .imgBtnsEdit {
  display: none;
}

.pc-container .imgBtnsAdd {
  display: none;
}
</style>

<style lang="less" scoped>
  @import '../../assets/css/global.less';
  .bg {
    position: relative;
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    // background: rgba(50, 59, 75, 0.3);
    // border-radius: 2px;
    // backdrop-filter: blur(1.6px);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    z-index: 100000003;

    .greyBg {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: -1;
      width: 100%;
      height: 100%;
      background: rgba(50, 59, 75, 0.3);
      border-radius: 2px;
      backdrop-filter: blur(1.6px);
    }

    .phone-container {
      position: relative;

      .close {
        position: absolute;
        top: 0em;
        right: -0.6em;
        width: 0.31em;
        height: 0.31em;
        user-select: none;
        cursor: pointer;
        z-index: 999;
      }

      .tags {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        padding: 0 0.15em;
        box-sizing: border-box;

        p {
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 0.14em;
          padding: 0.36em 0.71em;
          border-radius: 10px;
          margin: 0.05em;
          background: #F7F7F7;
          color: #D6D5D6;
        }
      }

      .phone {
        display: flex;
        flex-direction: column;
        position: relative;
        width: 3.75em;
        height: 8.12em;
        background: #FFFFFF;
        border-radius: 0.36em;
        overflow: hidden;
        padding: 0.44em 0 0.83em;
        box-sizing: border-box;

        &.black {
          position: relative;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          background: #000;
          padding: 0;
          width: 2.48em;
          height: 5.37em;

          .info {
            width: 90%;
            position: absolute;
            left: 0;
            bottom: 0.4em;
            padding: 0 0.15em;
            display: flex;
            flex-direction: column;
            box-sizing: border-box;
            z-index: 999;

            .col {
              font-size: 0.15em;
              color: #FFF;
              margin-bottom: 0.1em;
            }

            p {
              font-size: 0.06em;
              color: #FFF;
              word-break: break-all;
            }
          }

          .threeBtn {
            position: absolute;
            right: 0.09em;
            bottom: 0.52em;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            z-index: 999;

            .icon {
              width: 0.32em;
              height: 0.32em;
              background: url('../../assets/img/newMediaShare/bMain.png') no-repeat;
              background-position: center center;
              background-size: 100% 100%;
            }

            .zan {
              width: 0.26em;
              height: 0.26em;
              background: url('../../assets/img/newMediaShare/zan.png') no-repeat;
              background-position: center center;
              background-size: 100% 100%;
              margin: 0.21em 0 0.24em;
            }

            .share {
              width: 0.26em;
              height: 0.26em;
              background: url('../../assets/img/newMediaShare/share.png') no-repeat;
              background-position: center center;
              background-size: 100% 100%;
            }
          }

          .bTop {
            position: absolute;
            top: 0.36em;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            width: 100%;
            padding: 0 0.07em;
            box-sizing: border-box;
            z-index: 999;

            i {
              display: block;
              width: 0.16em;
              height: 0.16em;

              &.back {
                background: url('../../assets/img/newMediaShare/back.png') no-repeat;
                background-position: center center;
                background-size: 100% 100%;
              }

              &.search {
                background: url('../../assets/img/newMediaShare/search.png') no-repeat;
                background-position: center center;
                background-size: 100% 100%;
              }
            }
          }

          video {
            width: 100%;
            height: auto;
          }
        }

        .phoneScroll {
          display: flex;
          flex-direction: column;
          overflow-y: auto;
          flex: 1;
          min-height: 0;

          &::-webkit-scrollbar {
            width: 0px;
          }
          &::-webkit-scrollbar-thumb {
            background: rgba(#dcdcdc, 0.3);
            border-radius: 0px;
          }

          img {
            max-width: 100% !important;
          }

          .title {
            display: flex;
            flex-direction: row !important;
            justify-content: space-between;
            align-items: center;
            width: 100%;
            padding: 0 0.15em;
            box-sizing: border-box;
            margin: 0.13em 0 0.06em;

            .l {
              flex: 1;
              min-width: 0;
              font-weight: bold;
              font-size: 0.15em;
              color: #050F0F;
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
            }

            .r {
              width: 0.18em;
              height: 0.18em;
              background: url('./assets/arrow.png') no-repeat;
              background-position: center center;
              background-size: 100% 100%;
            }
          }

          .content {
            font-weight: 500;
            font-size: 0.15em;
            color: #050F0F;
            padding: 1em;
            box-sizing: border-box;
            word-break: break-all;
          }
        }

        .bottomBtn {
          width: 100%;
          height: 0.66em;
        }

        .topLine {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 0.44em;
          z-index: 999;
        }
        .bottomLine {
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 0.83em;
          z-index: 999;
        }

        video {
          width: 100%;
          height: 2.11em;
        }

        .notice {
          font-size: 0.15em;
          // line-height: 0.24em;
          color: #323B4B;
          margin-top: 2px;
          font-weight: 500;

          i {
            color: #E61939;
          }
        }

        .shareIcon {
          width: 100%;
          height: 0.78em;
          margin-top: 0.08em;
        }
      }
    }

    .pc-container {
      display: flex;
      flex-direction: column;
      position: relative;
      width: 750px;
      min-height: 558px;
      background: #FFFFFF;
      box-shadow: 4px 4px 10px 0px rgba(5, 10, 15, 0.05);
      border-radius: 4px;
      padding: 30px 50px 8px;
      box-sizing: border-box;

      &::-webkit-scrollbar {
        width: 0px;
      }
      &::-webkit-scrollbar-thumb {
        background: rgba(#dcdcdc, 0.3);
        border-radius: 0px;
      }

      .tags {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        box-sizing: border-box;

        p {
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 9px;
          padding: 3px 8px;
          border-radius: 10px;
          margin: 5px 5px 5px 0;
          background: #F7F7F7;
          color: #D6D5D6;
          box-sizing: border-box;
        }
      }

      .close {
        position: absolute;
        top: -20px;
        right: -50px;
        width: 31px;
        height: 31px;
        user-select: none;
        cursor: pointer;
        z-index: 999;
      }

      .title {
        width: 100%;
        font-weight: bold;
        font-size: 20px;
        color: #323B4B;
        height: 28px;
        min-height: 28px;
        line-height: 28px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        margin-bottom: 14px;
      }

      .pcNumber {
        width: 486px;
        height: 15px;
        margin-bottom: 14px;
      }

      video {
        width: 596px;
        height: 336px;
      }

      .pcWatch {
        width: 596px;
        height: 64px;
      }

      .content {
        width: 596px;
        margin: 10px 0;
        font-weight: 500;
        font-size: 9px;
        color: #050F0F;
        word-break: break-all;
      }

      .pcTag {
        width: 596px;
        height: 18px;
      }
    }

    .switch-container {
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-top: 30px;

      .btn {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        width: 128px;
        height: 44px;
        background: #FFFFFF;
        border-radius: 22px;
        user-select: none;
        cursor: pointer;

        &.bili {
          img {
            width: 24px;
            height: 24px;
          }
        }

        &.b {
          img {
            width: 20px;
            height: 20px;
          }
        }

        &.un {
          opacity: 0.5;
        }

        img {
          width: 21px;
          height: 26px;
          margin-right: 9px;
        }

        p {
          font-size: 14px;
          line-height: 44px;
          color: #323B4B;
          font-weight: bold;
        }

        &:nth-of-type(2) {
          margin-left: 30px;
        }
      }
    }

    .progress {
        position: absolute;
        left: 0;
        bottom: 0.2em;
        width: 100%;
        height: 2px;
        background: #666;

        .line {
          position: absolute;
          top: 0;
          left: 0;
          height: 2px;
          background: #FFF;
        }
      }

      .dy-container {
      display: flex;
      justify-content: center;
      align-items: center;
      max-height: 100%;
      max-width: 100%;
      overflow: hidden;
      background: #000;

      video {
        width: 100% !important;
        height: auto !important;
        max-height: calc(100vh - 1.68em);
      }

      .top {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 0.88em;
        background: url('../../assets/img/dy/top.png') no-repeat;
        background-position: center center;
        background-size: 100% 100%;
      }

      .message {
        width: 2.65em;
        position: absolute;
        left: 0.12em;
        bottom: 0.93em;
        display: flex;
        flex-direction: column;
        color: #FFF;
        
        .name {
          font-size: 0.16em;
          font-weight: bold;
          margin-bottom: 0.08em;
        }

        .content {
          font-size: 0.13em;
          margin-bottom: 0.08em;

          .word {
            &.on {
              word-break: break-all;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 3;
              -webkit-box-orient: vertical;
            }
          }
        }

        .from {
          display: flex;
          flex-direction: row;
          align-items: center;

          img {
            width: 0.13em;
            height: 0.13em;
            margin-right: 0.04em;
          }

          span {
            font-size: 0.14em;
          }
        }
      }

      .btn {
        position: absolute;
        right: 0;
        bottom: 0.92em;
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 0.51em;

        .avatar {
          display: flex;
          width: 0.51em;
          height: 0.51em;
          border-radius: 50%;
          overflow: hidden;
          margin-bottom: 0.28em;

          img {
            width: 100%;
            height: 100%;
            border-radius: 50%;
          }
        }

        .icon {
          display: flex;
          flex-direction: column;
          align-items: center;
          margin-bottom: 0.2em;

          img {
            width: 0.39em;
            height: 0.39em;
            margin-bottom: 0.04em;
          }

          p {
            font-size: 0.13em;
            line-height: 0.15em;
            font-weight: bold;
            color: #FFF;
          }
        }

        .disk {
          position: relative;
          margin-top: -0.3em;

          .disk1 {
            width: 0.46em;
            height: 0.46em;
          }

          .sound {
            position: absolute;
            top: 0.6em;
            left: -0.41em;
            width: 0.61em;
            height: 0.66em;
          }
        }
      }

      .bottom {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 0.8em;
        background: url('../../assets/img/dy/bottom.png') no-repeat;
        background-position: center center;
        background-size: 100% 100%;
      }
    }
  }

  .copyright {
    color: #E61939;
    font-weight: bold;
    text-align: center;
    margin: 20px 0;
  }

  .threeShareIcon {
    width: 161px;
    height: 40px;
    position: absolute;
    top: 59px;
    right: 50px;
  }
</style>

<style lang="less">
  .phoneScroll {
    img,video {
      max-width: 100%;
    }
  }
</style>